import { render, staticRenderFns } from "./CourierComponents.vue?vue&type=template&id=02043e76&"
import script from "./CourierComponents.vue?vue&type=script&lang=js&"
export * from "./CourierComponents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports